<template>
  <div class="coach-court-list profile-court-list">
    <ul class="nav">
      <li><router-link to="/user/sua-thong-tin">Thông tin</router-link></li>
      <li>
        <router-link to="/user/doi-mat-khau">Đổi mật khẩu</router-link>
      </li>
      <li>
        <router-link to="/user/thiet-lap-khac">Thiết lập khác</router-link>
      </li>
    </ul>
  </div>
</template>
